import { render, staticRenderFns } from "./ReferencedCalendarWidget.vue?vue&type=template&id=327ca19d"
import script from "./ReferencedCalendarWidget.vue?vue&type=script&lang=js"
export * from "./ReferencedCalendarWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports